module.exports = __webpack_public_path__ + "img/Simple Purple.abed31a4.jpg";